import { Dialog, Flex, Notice, Text } from '@applyboard/crystal-ui'
import { Dispatch, SetStateAction } from 'react'
import { FlywireButton } from '../../../components/Payments'
import { StudentApplication } from '../../../components/Application/types'

export function PayAndSubmitApprovalDialog(props: {
  showSubmitApprovalDialog: boolean
  setShowSubmitApprovalDialog: Dispatch<SetStateAction<boolean>>
  application: StudentApplication
}) {
  if (!props.showSubmitApprovalDialog) {
    return null
  }

  return (
    <Dialog
      onOpenChange={open => {
        props.setShowSubmitApprovalDialog(open)
      }}
      open={props.showSubmitApprovalDialog}
    >
      <Dialog.Heading>Ready to submit?</Dialog.Heading>
      <Dialog.Content>
        <Flex direction="column" justify="center" align="center" gap={4}>
          <Notice actionText="" intent="primary" width="fill">
            Please note that you will not be able to make any changes to this application after
            submission.
          </Notice>
          <Text variant="bodyM">Well done! This application is ready for submission.</Text>
          <Text variant="bodyM" contrast="low" align="center">
            But first, you will need to pay the non-refundable application fee. Once your payment is
            processed, this application will automatically be submitted.
          </Text>
        </Flex>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill">Cancel</Dialog.CloseButton>
        <FlywireButton
          onClick={() => {
            props.setShowSubmitApprovalDialog(false)
          }}
          application={props.application}
        />
      </Dialog.Actions>
    </Dialog>
  )
}
